// extracted by mini-css-extract-plugin
export var container = "_qu-0";
export var dotAnimation = "_qu-2";
export var dotsLoading = "_qu-1";